import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FORM_TEACHER_LABEL } from '../../constants/translationLabels/formElements';
import { RHFAutocomplete } from '../../share/rhf';
import { getTeacherFullName } from '../../helper/renderTeacher';

const TeachersList = ({ control, setValue }) => {
    const { t } = useTranslation('common');
    const teachers = useSelector((state) => state.teachers.teachers);

    return (
        <RHFAutocomplete
            control={control}
            name="teacher"
            options={teachers || []}
            label={t(FORM_TEACHER_LABEL)}
            getOptionLabel={(teacher) => (teacher ? getTeacherFullName(teacher) : '')}
            className="schedule-form_teacher"
            onAfterChange={(value) => {
                if (value) {
                    setValue('group', null);
                    setValue('department', null);
                }
            }}
        />
    );
};

export default TeachersList;
